import { ArrowRight } from 'lucide-react';

export function CTABannerSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="container relative">
        <div className="mx-auto max-w-3xl text-center">
          {/* Badge */}
          <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-purple-100 border border-purple-200 px-5 py-2 text-sm">
            <span className="text-purple-700 font-medium">Start Your Free Trial Today</span>
          </div>

          {/* Headline */}
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl mb-6 text-slate-900">
            Ready to Eliminate Position Limit{' '}
            <span className="text-purple-600">
              Compliance Stress
            </span>
            ?
          </h2>

          {/* Subheadline */}
          <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto">
            Join hundreds of compliance professionals who trust PositionIQ to keep them ahead of position limit regulations.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#demo"
              onClick={(e) => scrollToSection(e, '#demo')}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-purple-600 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-purple-700 transition-colors w-full sm:w-auto"
            >
              <span>Schedule a Demo</span>
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#waitlist"
              onClick={(e) => scrollToSection(e, '#waitlist')}
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-slate-300 bg-white px-8 py-4 text-base font-semibold text-slate-700 hover:bg-slate-50 hover:border-slate-400 transition-colors w-full sm:w-auto"
            >
              Join the Waitlist
            </a>
          </div>

          {/* Trust Note */}
          <p className="mt-10 text-sm text-slate-500">
            No credit card required. 14-day free trial. Cancel anytime.
          </p>
        </div>
      </div>
    </section>
  );
}
